import useRecording from '@app/hooks/recordings/useRecording';
import { useEffect, useState } from 'react';

export type InteractionAudioProps = {
    id: string;
    url: string;
};

export const InteractionAudio = ({ id, url }: InteractionAudioProps) => {
    const [audioSrc, setAudioSrc] = useState<string | undefined>(undefined);
    const { data: recordingResponse } = useRecording({ id }, { enabled: Boolean(url) });

    useEffect(() => {
        const recordingBlob = recordingResponse?.blob ?? null;
        if (!recordingBlob) {
            setAudioSrc(undefined);
            return;
        }

        const url = URL.createObjectURL(recordingBlob);
        setAudioSrc(url);
        return () => URL.revokeObjectURL(url);
    }, [recordingResponse]);

    return (
        <audio
            src={audioSrc}
            title={recordingResponse?.filename || url}
            controls
            style={{ width: '100%' }}
        />
    );
};

export default InteractionAudio;
